<template>
    <div class="editor" :class="{'disabled':data.disabled}">
        <textarea :id="inputFieldId" :name="name"/>
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "TextEditor",
    mixins: [InputMixin],
    mounted() {
        $("#" + this.inputFieldId).on("summernote.change", () => {
            this.input()
        });
        $("#" + this.inputFieldId).on("summernote.focus", () => {
            
            if($(".site-container").length > 0){

                $(".note-toolbar").removeClass("active");
                $("#" + this.inputFieldId).parent().find(".note-toolbar").addClass("active");

                $(".content-wrapper").addClass("summernote-init"); 
                setTimeout(function(){ 
                    $(".site-container").addClass("summernote-loaded"); 
                }, 750);

                $('div.note-editor').removeClass('codeview');
                $('div.note-editor .note-btn').prop("disabled", false).removeClass('disabled');
                $('div.note-editor.codeview button').removeClass('disabled');
                $("div.note-editor.codeview button[data-event='codeview']").removeClass('active').addClass('disabled');
                
            }
        });


        
        setTimeout(() => {
            this.initComponent(this.value);
        })
    },
    watch: {
        editorValue: function (value) {
            if (!value)
                this.setInitValue(value);
        }
    },
    computed: {
        editorValue() {
            return this.value;
        }
    },
    methods: {
        initComponent(initialValue) {
            let config = {
                placeholder: this.data.placeholder,
                dialogsInBody: true,
                height: this.data.height,
                disableDragAndDrop: true,
                callbacks: {
                    onPaste: function (e) {
                        var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        e.preventDefault();
                        document.execCommand('insertText', false, bufferText);
                    },
                }
            };

            if (Object.keys(this.data.textEditorHints).length) {
                config.hint = this.data.textEditorHints
            }

            $("#" + this.inputFieldId).summernote(config);
            this.setInitValue(initialValue);
        },

        setInitValue(initialValue) {
            $("#" + this.inputFieldId).summernote('code', initialValue);
        },
        input() {
            this.fieldValue = $('#' + this.inputFieldId).summernote('code');
            this.$emit('input', this.fieldValue);
        }
    }
}
</script>
